import React, { useState } from 'react';
import { CheckCircle2, Loader2, Send } from 'lucide-react';
import { company } from '../mock';
import { useAntiBot, Honeypot } from './useAntiBot';
import TurnstileWidget, { TURNSTILE_ENABLED } from './TurnstileWidget';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ServiceLeadForm({ service }) {
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
  const [state, setState] = useState('idle'); // idle | sending | done | error
  const { hp, setHp, appendAntiBot } = useAntiBot();
  const [token, setToken] = useState('');
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (TURNSTILE_ENABLED && !token) { setState('error'); return; }
    setState('sending');
    try {
      const fd = new FormData();
      fd.append('name', form.name);
      fd.append('phone', form.phone);
      fd.append('email', form.email);
      fd.append('service', service);
      fd.append('message', form.message || `Requesting ${service} service.`);
      appendAntiBot(fd);
      if (token) fd.append('turnstile_token', token);
      const res = await fetch(`${API}/api/contact`, { method: 'POST', body: fd });
      if (!res.ok) throw new Error('bad');
      if (typeof window !== 'undefined') {
        const pagePath = window.location.pathname;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'lead_submitted', service, page: pagePath });
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', { service, page_path: pagePath });
        }
        window.dispatchEvent(new CustomEvent('lead_submitted', { detail: { service, page: pagePath } }));
      }
      setState('done');
    } catch (err) {
      setState('error');
    }
  };

  return (
    <div className="lead-form-card" data-testid="service-lead-form">
      {state === 'done' ? (
        <div className="contact-success" data-testid="service-lead-success">
          <span className="ic-sq"><CheckCircle2 size={26} /></span>
          <h3>Thanks &mdash; request received!</h3>
          <p>We&rsquo;ll reach out shortly. Need us now? Call <a href={company.phoneHref}>{company.phoneDisplay}</a>.</p>
        </div>
      ) : (
        <form className="contact-form" onSubmit={submit} data-testid="service-lead-form-el">
          <Honeypot value={hp} onChange={setHp} />
          <h3>Request Service</h3>
          <p className="lead-form-sub">Send a quick request and we&rsquo;ll get right back to you.</p>
          <div className="cf-row">
            <label>Name*<input required value={form.name} onChange={set('name')} data-testid="lead-name" /></label>
            <label>Phone*<input required value={form.phone} onChange={set('phone')} data-testid="lead-phone" /></label>
          </div>
          <label>Email*<input type="email" required value={form.email} onChange={set('email')} data-testid="lead-email" /></label>
          <label>How can we help?
            <textarea rows={3} value={form.message} onChange={set('message')} placeholder={`Tell us about your ${service.toLowerCase()} needs`} data-testid="lead-message" />
          </label>
          {state === 'error' && <p className="cf-error" data-testid="lead-error">Please complete the verification below, or call {company.phoneDisplay}.</p>}
          <TurnstileWidget onToken={setToken} />
          <button className="btn btn-gold" type="submit" disabled={state === 'sending'} data-testid="lead-submit">
            {state === 'sending' ? <><Loader2 size={16} className="spin" /> Sending&hellip;</> : <><Send size={16} /> Request Service</>}
          </button>
        </form>
      )}
    </div>
  );
}
